import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function Services() {
  return (
    <div style={{
      width: '100%',
      minHeight: '100vh',
      backgroundColor: '#05070a',
      color: '#c9d1d9',
      padding: '60px 20px',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      <Helmet>
        <title>The Matrix | Adonisian Services</title>
      </Helmet>

      <div style={{ maxWidth: '900px', width: '100%', textAlign: 'center', marginBottom: '50px' }}>
        <h1 style={{ color: '#ffca28', fontSize: '2.5rem', textTransform: 'uppercase', letterSpacing: '3px', marginBottom: '15px' }}>
          The Service Matrix
        </h1>
        <p style={{ fontSize: '1.1rem', lineHeight: '1.6', color: '#8b949e', maxWidth: '700px', margin: '0 auto' }}>
          Absolute precision. Choose your level of intervention. From passive, automated Astro-Somatic blueprints to live, high-stakes alignment facilitations with the Lead Architect.
        </p>
      </div>

      {/* --- TIER I: AUTOMATED GATEWAYS --- */}
      <div style={{ width: '100%', maxWidth: '900px', marginBottom: '50px' }}>
        <h2 style={{ color: '#ffffff', fontSize: '1.5rem', textTransform: 'uppercase', letterSpacing: '2px', borderBottom: '1px solid #30363d', paddingBottom: '10px', marginBottom: '25px' }}>
          Tier I: The Automated Gateways
        </h2>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '25px' }}>
          <div style={{ background: '#0d1117', border: '1px solid #30363d', borderRadius: '8px', padding: '30px', transition: 'all 0.3s ease', cursor: 'default' }}>
            <h3 style={{ color: '#00d4ff', margin: '0 0 10px 0', fontSize: '1.3rem' }}>The Somatic Blueprint</h3>
            <div style={{ color: '#ffca28', fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '15px' }}>$99</div>
            <p style={{ color: '#8b949e', fontSize: '0.95rem', lineHeight: '1.6', marginBottom: '25px' }}>
              The foundational 13-Sign True Astronomical report. Includes your exact cosmic coordinates, Core Palaces, and the raw data sheet mapping your planetary alignments directly to your cerebrospinal fluid and joint matrices.
            </p>
            <button style={{ background: 'transparent', color: '#00d4ff', border: '1px solid #00d4ff', padding: '10px 20px', borderRadius: '4px', cursor: 'pointer', textTransform: 'uppercase', fontSize: '0.8rem', fontWeight: 'bold', width: '100%' }}>
              Calculate on Portal
            </button>
          </div>

          <div style={{ background: '#0d1117', border: '1px solid #30363d', borderRadius: '8px', padding: '30px', transition: 'all 0.3s ease', cursor: 'default' }}>
            <h3 style={{ color: '#00d4ff', margin: '0 0 10px 0', fontSize: '1.3rem' }}>The Synastry Matrix</h3>
            <div style={{ color: '#ffca28', fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '15px' }}>$149</div>
            <p style={{ color: '#8b949e', fontSize: '0.95rem', lineHeight: '1.6', marginBottom: '25px' }}>
              The dual-chart automated relationship report. Maps the physical and energetic intersections between two physical vehicles and delivers your exact, unapologetic Karmic Homework.
            </p>
            <button style={{ background: 'transparent', color: '#00d4ff', border: '1px solid #00d4ff', padding: '10px 20px', borderRadius: '4px', cursor: 'pointer', textTransform: 'uppercase', fontSize: '0.8rem', fontWeight: 'bold', width: '100%' }}>
              Available in The Sanctuary
            </button>
          </div>
        </div>
      </div>

      {/* --- TIER II: LIVE FACILITATION --- */}
      <div style={{ width: '100%', maxWidth: '900px', marginBottom: '60px' }}>
        <h2 style={{ color: '#ffffff', fontSize: '1.5rem', textTransform: 'uppercase', letterSpacing: '2px', borderBottom: '1px solid #30363d', paddingBottom: '10px', marginBottom: '25px' }}>
          Tier II: The Live Facilitations
        </h2>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
          <div style={{ background: 'linear-gradient(145deg, #0d1117 0%, #111822 100%)', border: '1px solid #ffca28', borderRadius: '8px', padding: '30px', position: 'relative', overflow: 'hidden' }}>
            <h3 style={{ color: '#ffca28', margin: '0 0 10px 0', fontSize: '1.4rem' }}>The Astro-Somatic Consultation</h3>
            <div style={{ color: '#ffffff', fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '15px' }}>$333 <span style={{ fontSize: '0.9rem', color: '#8b949e', fontWeight: 'normal' }}>/ 60 Minutes</span></div>
            <p style={{ color: '#c9d1d9', fontSize: '1rem', lineHeight: '1.6', marginBottom: '25px', maxWidth: '700px' }}>
              A live, highly tactical phone or video facilitation. The Architect decodes your true alignments in real-time, addresses your physical and emotional friction points, and delivers direct bio-hacking protocols to optimize your physical vehicle.
            </p>
            <a href="mailto:adonis@adonisian.com?subject=Booking Inquiry: Astro-Somatic Consultation" style={{ display: 'inline-block', background: '#ffca28', color: '#0d1117', textDecoration: 'none', padding: '12px 25px', borderRadius: '4px', textTransform: 'uppercase', fontSize: '0.9rem', fontWeight: 'bold' }}>
              Request Availability
            </a>
          </div>

          <div style={{ background: 'linear-gradient(145deg, #0d1117 0%, #111822 100%)', border: '1px solid #ffca28', borderRadius: '8px', padding: '30px', position: 'relative', overflow: 'hidden' }}>
            <h3 style={{ color: '#ffca28', margin: '0 0 10px 0', fontSize: '1.4rem' }}>The Synastry Crucible</h3>
            <div style={{ color: '#ffffff', fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '15px' }}>$555 <span style={{ fontSize: '0.9rem', color: '#8b949e', fontWeight: 'normal' }}>/ 90 Minutes</span></div>
            <p style={{ color: '#c9d1d9', fontSize: '1rem', lineHeight: '1.6', marginBottom: '25px', maxWidth: '700px' }}>
              High-stakes relationship alignment. The Architect sits down with both partners, navigating your exact energetic polarities and actively guiding you through the somatic nodes where your physical vehicles collide or harmonize.
            </p>
            <a href="mailto:adonis@adonisian.com?subject=Booking Inquiry: The Synastry Crucible" style={{ display: 'inline-block', background: '#ffca28', color: '#0d1117', textDecoration: 'none', padding: '12px 25px', borderRadius: '4px', textTransform: 'uppercase', fontSize: '0.9rem', fontWeight: 'bold' }}>
              Request Availability
            </a>
          </div>
        </div>
      </div>

      {/* --- TIER III: THE SECRET SLY MENTION --- */}
      <div style={{ width: '100%', maxWidth: '900px', background: '#020305', border: '1px dashed #30363d', borderRadius: '8px', padding: '40px', textAlign: 'center' }}>
        <h3 style={{ color: '#484f58', fontSize: '1.1rem', textTransform: 'uppercase', letterSpacing: '4px', marginBottom: '15px' }}>
          Classified: Tier III
        </h3>
        <p style={{ color: '#8b949e', fontSize: '0.95rem', lineHeight: '1.8', maxWidth: '650px', margin: '0 auto 20px auto', fontStyle: 'italic' }}>
          There exists a third echelon of intervention. Designed strictly for those requiring bespoke 12-hour research deep-dives, custom Ayurvedic dietary alignments, and absolute God-Mode access to the Architect. Due to the intense temporal demands of these holistic lifestyle masterworks, Tier III commissions are entirely unlisted and are <strong>strictly by application and energetic alignment only.</strong>
        </p>
        <a href="mailto:adonis@adonisian.com?subject=Application Request: Tier III Commission" style={{ color: '#00d4ff', textDecoration: 'none', fontSize: '0.9rem', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1px', borderBottom: '1px solid rgba(0,212,255,0.3)', paddingBottom: '3px' }}>
          Transmit Application Inquiry
        </a>
      </div>

    </div>
  );
}